import React from 'react';
import { actions, selectors } from './';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';
import { Tabs, Pane } from '../../shared/tabs';
import Analytics from './components/Analytics';
import AllPromos from './components/AllPromos';

const Main = renderViewsState(props => {
	return (
		<Animate>
			<div className='container__content'>
				<div className='container__content-title'>
					<div className='container__content-title-position'>
						<Link to='programs/' className='link'>{props.intl('Return to list of programs')}</Link>
					</div>
					<div className='container__content-title-position'>
						<h1 className='title'>{props.intl('Offer info')}</h1>
					</div>
				</div>
				<div className='container__content-body'>
					<div className='form-container'>
						<div className='form-container__head'>
							<h2 className='title icon-edit'>{props.intl('Offer info')}</h2>
							{props.data.title && (
								<span className='item-title'>{props.data.title}</span>
							)}
						</div>
						<Tabs selected={props.currentTab} onTabChange={props.tabChange}>
							<Pane label={props.intl('Analytics')} index='analytics'>
								{props.analytics && (
									<Analytics
										calendar={{
											...props.calendar,
											onInit: props.calendarInit,
											onToggle: props.calendarToggle,
											onChange: props.calendarChange,
											onApply: props.calendarApply
										}}
										apply={props.applyAnalytics}
										locationsLookups={props.locationsLookups}
										trafficSources={props.trafficSources}
										analytics={props.analytics}
									/>
								)}
							</Pane>
							<Pane label={props.intl('All promos')} index='promos'>
								{props.promos && (
									<AllPromos
										locationsLookups={props.locationsLookups}
										promos={props.promos}
										apply={props.applyAllPromos}
									/>
								)}
							</Pane>
						</Tabs>
					</div>
				</div>
			</div>
		</Animate>
	);
}, 'view');

export default connect(
	state => ({
		data: selectors.getData(state),
		analytics: selectors.getAnalytics(state),
		promos: selectors.getPromos(state),
		trafficSources: selectors.getTrafficSources(state),
		calendar: selectors.getCalendar(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		currentTab: selectors.getCurrentTab(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/info/main.js